export interface CalendarEventType {
	title: string;
	style: string;
	value: CalendarEventTypeKey;
}

export enum CalendarEventTypeKey {
	SchoolYearStart = 'school_year_start',
	SchoolYearEnd = 'school_year_end',
	TermStart = 'term_start',
	TermEnd = 'term_end',
	SchoolClosed = 'school_closed',
	Misc = 'misc',
}

export const calendarEventTypes: CalendarEventType[] = [
	{
		title: 'School Year Start',
		style: 'text-green',
		value: CalendarEventTypeKey.SchoolYearStart,
	},
	{
		title: 'School Year End',
		style: 'text-yellow',
		value: CalendarEventTypeKey.SchoolYearEnd,
	},
	{
		title: 'Term Start',
		style: 'text-green',
		value: CalendarEventTypeKey.TermStart,
	},
	{
		title: 'Term End',
		style: 'text-yellow',
		value: CalendarEventTypeKey.TermEnd,
	},
	{
		title: 'School Closed',
		style: 'text-red',
		value: CalendarEventTypeKey.SchoolClosed,
	},
	{
		title: 'Misc',
		style: 'text-blue',
		value: CalendarEventTypeKey.Misc,
	},
];
